<template>
  <div class="ycqf">
    <van-nav-bar
        title="气费充值"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="margin0"/>

    <van-cell v-model="C_Code" icon="user-circle-o" size="large" >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{C_Name}}</span>
      </template>
    </van-cell>
    <van-cell  icon="wap-home-o">
      <template #title>
        <span class="custom-title2">{{C_Address}}</span>
      </template>
    </van-cell>

    <div class="margin1"/>




    <van-cell title="当前余额（元）" icon="balance-o">
      <template #default>
        <span class="value-default">{{myLeft}}</span>
      </template>
    </van-cell>


    <van-cell title="充值金额" value="" />
    <van-grid :border="false" :column-num="3">
      <van-grid-item>
        <el-radio v-model="radio1" :label="100" border size="large" @input="checkRadio">100元</el-radio>
      </van-grid-item>
      <van-grid-item>
        <el-radio v-model="radio1" :label="200" border size="large" @input="checkRadio">200元</el-radio>
      </van-grid-item>
      <van-grid-item>
        <el-radio v-model="radio1" :label="300" border size="large" @input="checkRadio">300元</el-radio>
      </van-grid-item>
    </van-grid>
    <!-- 允许输入正整数，调起纯数字键盘 -->
    <van-field
        v-model="payment"
        type="digit"
        input-align="center"
        placeholder="请输入或选择金额"
        clearable
        @input="setRadio">
      <template #left-icon>
        <van-icon class="left-icon" name="gold-coin-o" size="30px" color="#4894ff"/>
      </template>
    </van-field>

    <div style="margin: 16px;">
      <van-button square  block type="info" @click="onSubmit">提交</van-button>
    </div>






  </div>
</template>
<script>
import API from "@/api";
import {Toast} from "vant";
import { Dialog } from 'vant';

export default {
  name: 'page_ycqf',
  data() {
    return {
      radio1: '0',
      payment: '',
      C_ID:"",
      C_Code:"",
      C_Name:"",
      C_Address:"",
      myLeft:"",
      list: [],
      loading: false,
      finished: false,
      refreshing: false,

    };
  },
  methods: {

    onClickLeft(){
      this.$router.go(-1);
    },
    getCust() {
      if (this.$cookie.get('CID')===''||!this.$cookie.get('CID')) {
        Toast('请先绑定用户！')
        this.$router.push('/bindlist');
      } else {
        this.C_ID=this.$cookie.get('CID');
        this.C_Code=this.$cookie.get('C_Code');
        this.C_Address=this.$cookie.get('CAddress');
        this.C_Name=this.$cookie.get('CName');
      }

    },
    searchLeft() {
      this.$http.get(API.LookPreMoneyLeft,{
        params: {
          c_id:this.C_ID
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.myLeft=res.myLeft;
              this.$cookie.set('myLeft',res.myLeft,  { expires: '360m' });
            }
          })
    },
    checkRadio() {
      this.payment = ''
    },
    setRadio() {
      this.radio1 = '0'
    },
    onSubmit() {
      if ((this.radio1==='0')&&(this.payment==='')) {
        Toast('请选择或输入充值金额');
      } else {
        let pay =  '';
        if (this.radio1==='0') {
          pay =  this.payment;
        } else {
          this.payment= this.radio1
          pay = this.payment
        }

        Dialog.confirm({
          title: '提示',
          message:  '用户：' + this.C_Name + '(' + this.C_Code + ')'  + '\n'
              + '充值金额：' + pay + ' 元 \n是否继续充值',
        })
            .then(() => {
              // on confirm
              Toast.loading({
                message: '请稍候...',
                forbidClick: true,
                duration: 0 ,
              });
              this.order();
            })
            .catch(() => {
              // on cancel
              Toast('取消支付')
            });

      }
    },
    order() {
      this.$http.get(API.PreMoneyOrder,{
        params: {
          c_id:this.C_ID,
          WP_PAYMEN:this.payment
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.WP_ID = res.message;
              //Toast(res.message)
              this.searchOrder();
            } else {
              Toast.clear();
            }
          });

    },
    searchOrder() {
      let _this=this
      setTimeout(function () {
        _this.searchOrderFunction();
      },500)
    },
    searchOrderFunction() {
      this.$http.get(API.searchOrder,{
        params: {
          WP_ID:this.WP_ID
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              if (res.WP_Flag == 1) {
                console.log('准备调用微信支付1.2')
                this.searchOrder();
              } else if (res.WP_Flag == 3) {
                console.log('准备调用微信支付1.1')
                //Toast('准备调用微信支付1.1');
                this.orderPay(res);
              } else if (res.WP_Flag == 0) {

                console.log('准备调用微信支付1.3')
                this.searchOrder();
              } else {
                console.log('准备调用微信支付1.4')
                Toast.clear();
                Toast('下单失败，请稍候重试')
              }

            } else {
              console.log('准备调用微信支付1.5')
              Toast.clear();
              Toast('下单失败，请稍候重试')
            }
          });
    },
    orderPay(res) {
      console.log('准备调用微信支付2')
      //Toast('准备调用微信支付2')
      let vm = this
      if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
        console.log('准备调用微信支付3.1')
        //Toast()
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(res), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(res))
          document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(res))
        }
      } else {
        console.log('准备调用微信支付3.2')
        vm.onBridgeReady(res)
      }
    },
    onBridgeReady (data) {
      console.log('调用微信支付WeixinJSBridge')
      var vm = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.WP_appId, // 公众号名称，由商户传入
            'timeStamp': data.WP_timeStamp, // 时间戳
            'nonceStr': data.WP_nonceStr, // 随机串
            'package': data.WP_package, // 预支付id
            'signType': data.WP_signType, // 微信签名方式
            'paySign': data.WP_paySign // 微信签名
          },
          function (res) {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {

              vm.$http.get(API.PayADSus,{
                params: {
                  WP_ID:vm.WP_ID
                }
              })
                  .then((response)=>{
                    let res = response.data;
                    if (res.code === 0) {
                      Toast.clear();
                      Toast('支付成功');
                      vm.$router.go(0)
                    } else {
                      Toast.clear();
                      Toast('支付成功');
                      vm.$router.go(0)
                    }
                  });

            } else {
              vm.$http.get(API.PayADFail,{
                params: {
                  WP_ID:vm.WP_ID
                }
              })
                  .then((response)=>{
                    let res = response.data;
                    if (res.code === 0) {
                      Toast.clear();
                      Toast('支付失败，请稍候重试');
                      vm.$router.go(0)
                    } else {
                      Toast.clear();
                      Toast('支付失败，请稍候重试');
                      vm.$router.go(0)
                    }
                  });
            }
          }
      )
    },


  },
  mounted () {
    this.getCust();
    this.searchLeft();

  }
}
</script>
<style>
.value-default {
  font-size: large;
  color: #4894ff;
}




</style>